<app-itopia-loader *ngIf="loading || isLinkingRedirect"></app-itopia-loader>
<div class="login-container" *ngIf="!loading && !isEmptyProviderCredentials && !isLinkingRedirect">
  <div class="glass-card">
    <div  fxLayoutAlign="center center" fxLayout="row">
       <img src="{{resources[6]}}" alt="cloudapps logo" class="logo" />
    </div>
    <h1 class="m-b-0 m-t-0 h-welcome">Welcome to the<br />Admin Portal</h1>
    <p>Sign in using your organization’s account to manage your resources.</p>

       <div class="login-buttons">
            <button mat-stroked-button [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn microsoft" (click)="signInWithMicrosoft()">
                <img class="microsoft" src="{{resources[2]}}" alt="Microsoft" />
                Sign in with Microsoft
            </button>

            <button mat-stroked-button  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn google" (click)="signIn()">
                <img class="google" src="{{resources[1]}}" alt="Google" />
                Sign in with Google
            </button>

            <button mat-stroked-button  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn classlink" (click)="signInWithClassLink()">
                <img class="classlink" src="{{resources[3]}}" alt="ClassLink" />
                Sign in with ClassLink
            </button>

            <button mat-stroked-button *ngIf="showCleverAuth"  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn classlink" (click)="signInWithClever()">
                <img class="classlink" src="{{resources[5]}}" alt="ClassLink" />
                Sign in with Clever
            </button>
    </div>   

    <div class="student-portal-button" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div>
          <span>Not an Admin?</span>
        </div>
        <button mat-stroked-button color="primary" (click)="goToStudentPortal()">
            <mat-icon>open_in_new</mat-icon>
            Go to Student Portal
        </button>
     </div>
        <div fxLayout="row" class="progress" *ngIf="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited">
        <mat-progress-bar class="progress" mode="indeterminate" ></mat-progress-bar>
    </div>
  </div>
   
</div>

<!----exist different credentials--->
<div class="login-container" *ngIf="!loading && !isLinkingRedirect && isEmptyProviderCredentials">
  <div class="glass-card">
    <img src="{{resources[6]}}" alt="cloudapps logo" class="logo" />
    <div fxLayout="column"  fxLayoutAlign="center center">
      <mat-icon style="color:orange" class="ico-warn-credentials">warning</mat-icon>
      <h3 class="m-b-10 m-l-5  h3-title-credential"> Link Your Account to Enable Microsoft Sign-In</h3>
    </div> 
    <p class="p-credentials">It is not possible to sign in with Microsoft because the account you are trying to use was originally created with a provider that requires linking. To continue, please authenticate with your provider, and you will then be automatically redirected to Microsoft to complete the sign-in process.</p>

     <div class="login-buttons">      
            <button mat-stroked-button  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn classlink" (click)="signInWithClassLink()">
                <img class="classlink" src="{{resources[3]}}" alt="ClassLink" />
                Sign in with ClassLink
            </button>

            <button mat-stroked-button *ngIf="showCleverAuth"  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn classlink" (click)="signInWithClever()">
                <img class="classlink" src="{{resources[5]}}" alt="ClassLink" />
                Sign in with Clever
            </button>

          <button mat-stroked-button  [disabled]="classLinkSubmited || microsoftSubmited || googleSubmited || cleverSubmited" class="login-btn google" (click)="signIn()">
                <img class="google" src="{{resources[1]}}" alt="Google" />
                Sign in with Google
           </button>
      </div>
   

     <div class="student-portal-button" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button mat-stroked-button color="primary" (click)="goToBackCredentials()">
         <mat-icon class="m-r-0">arrow_back</mat-icon><span class="m-r-5"> Go Back </span>
         </button>     
        <div fxLayout="row" class="progress" *ngIf="classLinkSubmited || cleverSubmited">
             <mat-progress-bar class="progress" mode="indeterminate" ></mat-progress-bar>
        </div>
    </div>
  </div>
   
</div>

